"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsxs)("svg", {
    id: "uuid-31ddb743-3a23-451a-95d3-ec4204ed07d7",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 358.34 442.61",
    width: "100%",
    height: "100%",
    children: [(0, jsx_runtime_1.jsx)("path", {
      d: "M275.29,375.62c0,7.87-6.41,14.28-14.28,14.28H97.33c-7.87,0-14.28-6.41-14.28-14.28v-34.6H39.6v101.6H318.74v-101.6h-43.45v34.6Zm14,0v-20.6h15.45v73.6H53.6v-73.6h15.45v20.6c0,15.59,12.69,28.28,28.28,28.28h163.68c15.59,0,28.28-12.69,28.28-28.28Z",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M291.94,177.42v-28.59h-14v28.59c0,6.33-5.15,11.48-11.48,11.48h-34.18v14h34.18c14.05,0,25.48-11.43,25.48-25.48Z",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M139.61,185.37h-2.24v107.07h83.61v-107.07h-81.37Zm46.56,79.6c0,3.87-3.13,7-7,7s-7-3.13-7-7v-49.91c0-3.87,3.13-7,7-7s7,3.13,7,7v49.91Z",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M286.14,0H0V57.48c0,12.68,10.32,23,23,23h13.47v33.89c0,12.77,10.39,23.16,23.16,23.16h34.77v12.9c0,14.05,11.43,25.48,25.48,25.48h118.59c14.05,0,25.48-11.43,25.48-25.48v-12.9h34.77c12.77,0,23.16-10.39,23.16-23.16v-33.89h13.47c12.68,0,23-10.32,23-23V0h-72.2Zm-36.19,150.42c0,6.33-5.15,11.48-11.48,11.48H119.87c-6.33,0-11.48-5.15-11.48-11.48v-12.9H249.95v12.9Zm57.93-36.05c0,5.05-4.11,9.16-9.16,9.16H59.63c-5.05,0-9.16-4.11-9.16-9.16v-33.89H307.87v33.89Zm36.47-56.89c0,4.96-4.04,9-9,9H23c-4.96,0-9-4.04-9-9V14H291.62l52.72,.02V57.48Z",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M106.72,109H251.62c3.87,0,7-3.13,7-7s-3.13-7-7-7H106.72c-3.87,0-7,3.13-7,7s3.13,7,7,7Z",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M334.03,294.1v-.02s-56.86,.15-58.74,.41c-20.44,2.82-36.23,20.39-36.23,41.59v4.93H119.28v-4.93c0-21.2-15.79-38.77-36.23-41.59-1.89-.26-58.74-.41-58.74-.41v.02c-3.75,.13-6.75,3.2-6.75,6.98s3,6.85,6.75,6.98h0s56.88,.22,58.74,.62c12.68,2.67,22.23,13.94,22.23,27.4v18.93H253.06v-18.93c0-13.46,9.55-24.73,22.23-27.4,1.86-.39,58.74-.6,58.74-.6v-.02c3.72-.17,6.68-3.22,6.68-6.98s-2.96-6.81-6.68-6.98Z",
      fill: "currentColor"
    })]
  });
};

exports.default = Icon;